export const APPLY_PERMISSION = "APPLY_PERMISSION";
export const REMOVE_PERMISSION = "REMOVE_PERMISSION";
export const APPLY_ROLES = "APPLY_ROLES";
